<template>
  <portal to="confirm-modal">
    <local-notification-prompt
      v-if="visible"
      :key="promptKey"
      :force-show="forceShow"
      :start-awaiting="startAwaiting"
      :unsupported="unsupported"
      :force-ios="forceIOS"
      @close="onClose"
    />
  </portal>
</template>

<script>
import notificationPromptService from '@/services/notificationPromptService'
import LocalNotificationPrompt from '@/components/popups/main-popups/LocalNotificationPrompt.vue'
import { shouldShowNotificationPrompt } from '@/utils/notificationPrompt'

export default {
  name: 'NotificationPromptManager',
  components: { LocalNotificationPrompt },
  data() {
    return {
      visible: false,
      forceShow: false,
      startAwaiting: false,
      unsupported: false,
      forceIOS: false,
      promptKey: 0,
      autoPromptTimer: null,
      autoPromptCheckId: 0
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/user']
    },
    canAutoPrompt() {
      return (
        !!this.$store.state.auth.token &&
        !!this.user?.id &&
        this.user.requireRegistration === false &&
        this.$route.matched.some((record) => record.meta?.notificationPrompt)
      )
    }
  },
  watch: {
    '$route.fullPath'() {
      this.scheduleAutoPrompt()
    },
    '$store.state.auth.token'() {
      this.scheduleAutoPrompt()
    },
    'user.id'() {
      this.scheduleAutoPrompt()
    },
    'user.requireRegistration'() {
      this.scheduleAutoPrompt()
    }
  },
  created() {
    this.unsubscribe = notificationPromptService.subscribe((payload) => {
      this.showPrompt(payload)
    })
  },
  mounted() {
    this.scheduleAutoPrompt()
  },
  beforeDestroy() {
    this.unsubscribe?.()
    clearTimeout(this.autoPromptTimer)
  },
  methods: {
    showPrompt(payload = {}) {
      if (payload.close) {
        this.onClose()
        return
      }
      this.forceShow = !!payload.force
      this.startAwaiting = !!payload.startAwaiting
      this.unsupported = !!payload.unsupported
      this.forceIOS = !!payload.forceIOS
      this.promptKey += 1
      this.visible = true
    },
    scheduleAutoPrompt() {
      clearTimeout(this.autoPromptTimer)
      if (!this.canAutoPrompt || this.visible) return

      this.autoPromptTimer = setTimeout(() => {
        this.showAutoPrompt()
      }, 600)
    },
    async showAutoPrompt() {
      const checkId = ++this.autoPromptCheckId
      const shouldShow = await shouldShowNotificationPrompt(this.$api, this.$store)

      if (checkId !== this.autoPromptCheckId || !shouldShow || this.visible || !this.canAutoPrompt) return

      this.showPrompt()
    },
    onClose() {
      this.visible = false
      notificationPromptService.notifyClosed()
      this.scheduleAutoPrompt()
    }
  }
}
</script>
